import { useTenantData } from "contexts/tenant";
import { MessageType } from "src/store/api/generatedApi";

export const useMessageType = (): MessageType => {
  const tenantData = useTenantData();

  return tenantData.message_type;
};
